import { Injectable } from '@angular/core';
import { map } from 'rxjs';

import { SearchedPlaceState } from './searched-place.state';
import { Store } from '../../../../shared/store';
import { Place } from '../../models/place.interface';

const searchedPlaceState = new SearchedPlaceState();

@Injectable({ providedIn: 'root' })
export class SearchedPlaceStore extends Store<SearchedPlaceState> {
  searchedPlace$ = this.state$.pipe(map((s) => s.searchedPlace));

  constructor() {
    super(searchedPlaceState);
  }

  setSearchedPlace(nextSearchedPlace: Place | null) {
    this.setState({ ...this.state, searchedPlace: nextSearchedPlace });
  }
}
